import authCheckApp from './authCheckApp'

/**
 * 发送处理消息，可用于刷新常用微服务列表
 * @since 1.0.0
 * @param {Object} obj - 发送的消息
 * @param {string} obj.noticeName 处理消息'MicroServiceCommentRefresh'
 * @returns {string} 返回状态
 * @example
 * 
 * noticeBroad({
 *   "noticeName":"MicroServiceCommentRefresh"
 * })
 */
function noticeBroad(obj) {
    return new Promise((resolve, reject) => {
        authCheckApp()
            .then(() => {
                // 发起请求
                window.WebViewJavascriptBridge.callHandler('noticeBroad', {
                    'noticeName': obj.noticeName
                }, (response) => {
                    if (typeof response === 'string') {
                        response = JSON.parse(response)
                    }
                    // 返回状态值为0成功
                    if (response.status === 0) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                })
            }).catch(err => {
                reject(err)
            })
    })
}

export default noticeBroad